import { render, staticRenderFns } from "./CreateModal.vue?vue&type=template&id=0695ffc2&"
import script from "./CreateModal.vue?vue&type=script&lang=js&"
export * from "./CreateModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0695ffc2')) {
      api.createRecord('0695ffc2', component.options)
    } else {
      api.reload('0695ffc2', component.options)
    }
    module.hot.accept("./CreateModal.vue?vue&type=template&id=0695ffc2&", function () {
      api.rerender('0695ffc2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/organization/staffs/CreateModal.vue"
export default component.exports